import { useEffect, useRef, useCallback } from "react";
import Lenis from "lenis";
import { SettingsProvider } from "@/context/SettingsContext";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { PrayerDeclaration } from "@/components/PrayerDeclaration";
import { Prophetic } from "@/components/Prophetic";
import { Beliefs } from "@/components/Beliefs";
import { Appointment } from "@/components/Appointment";
import { BibleSearch } from "@/components/BibleSearch";
import { About } from "@/components/About";
import { Gallery } from "@/components/Gallery";
import { Books } from "@/components/Books";
import { Community } from "@/components/Community";
import { Events } from "@/components/Events";
import { Blog } from "@/components/Blog";
import { Give } from "@/components/Give";
import { Testimonies } from "@/components/Testimonies";
import { FAQ } from "@/components/FAQ";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Home() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  const scrollToId = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenisRef.current) {
      lenisRef.current.scrollTo(el, { offset: id === "home" ? 0 : -72 });
    } else {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  // Honour /#section deep-links arriving from the dedicated SEO routes.
  useEffect(() => {
    const hash = window.location.hash?.replace("#", "");
    if (!hash) return;
    const t = setTimeout(() => {
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 350);
    return () => clearTimeout(t);
  }, []);

  return (
    <SettingsProvider>
    <div className="bg-parchment dark:bg-ink text-foreground">
      <Navbar scrollToId={scrollToId} />
      <main>
        <Hero scrollToId={scrollToId} />
        <PrayerDeclaration />
        <Prophetic />
        <Beliefs />
        <Appointment />
        <BibleSearch />
        <About />
        <Gallery />
        <Books scrollToId={scrollToId} />
        <Community />
        <Events scrollToId={scrollToId} />
        <Blog />
        <Give />
        <Testimonies />
        <FAQ />
        <Contact />
      </main>
      <Footer scrollToId={scrollToId} />
    </div>
    </SettingsProvider>
  );
}
